var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"table-item-product-box"},[_c('img',{staticClass:"table-item-product-box__thumbnail",attrs:{"src":_vm.src}}),_c('button',{staticClass:"table-item-product-box__name",attrs:{"type":"button"},on:{"click":_vm.click}},[_vm._v(" "+_vm._s(_vm.name)+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }